var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-layout__section" },
    [
      _c("h5", { staticClass: "report-layout__title" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _vm._l(_vm.rows, function (columns, index) {
        return _c("section-row", {
          key: index,
          staticClass: "tile is-ancestor",
          attrs: {
            columns: columns,
            "hospital-id": _vm.hospitalId,
            "listing-id": _vm.listingId,
            "organisation-id": _vm.organisationId,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }